import { useEffect } from 'react';

export default function ExtensionErrorGuard() {
  useEffect(() => {
    const isTargetExtensionError = (msg, stack, filename) => {
      const text = `${msg || ''} ${stack || ''} ${filename || ''}`;
      return (
        text.includes('M_ID') ||
        text.includes('chrome-extension://') ||
        text.includes('moz-extension://') ||
        text.includes('executors/200.js') ||
        text.includes('FedCM')
      );
    };

    const handleGlobalError = (event) => {
      const msg = event.message || event.error?.message;
      const stack = event.error?.stack;
      const filename = event.filename;

      if (isTargetExtensionError(msg, stack, filename)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
    };

    const handleUnhandledRejection = (event) => {
      const msg = event.reason?.message || String(event.reason || '');
      const stack = event.reason?.stack;

      if (isTargetExtensionError(msg, stack)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
    };

    const origOnError = window.onerror;
    window.onerror = (msg, url, line, col, error) => {
      const errStr = String(msg || '') + ' ' + String(url || '');
      if (errStr.includes('M_ID') || errStr.includes('chrome-extension://') || errStr.includes('executors/200.js')) {
        return true;
      }
      if (origOnError) {
        return origOnError(msg, url, line, col, error);
      }
      return false;
    };

    window.addEventListener('error', handleGlobalError, true);
    window.addEventListener('unhandledrejection', handleUnhandledRejection, true);

    return () => {
      window.removeEventListener('error', handleGlobalError, true);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection, true);
      window.onerror = origOnError;
    };
  }, []);

  return null;
}
